import React, { Suspense, useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, OrbitControls } from '@react-three/drei';
import HashupCartridgeModel from './hashupCartridgeModel';
import { Bloom, EffectComposer, SMAA } from '@react-three/postprocessing';
import { Spinner } from '@chakra-ui/react';

export enum Cartridge {
	GOLD,
	SILVER,
	CUSTOM,
	_ /** Null cartridge */,
}

const hdrMaps: { [p: number]: string } = {
	[Cartridge.GOLD]: '/assets/models/zloty/zloty.hdr',
	[Cartridge.SILVER]: '/assets/models/szary/szary.hdr',
	[Cartridge.CUSTOM]: '/assets/models/teczowy/teczowy.hdr',
	[Cartridge._]: '/assets/models/pusty/pusty.hdr',
};

export enum TextureMap {
	FALLBACK = '/assets/models/pusty/dopodmiany.jpg',
}

export interface IHashupCartridge {
	cartridge: Cartridge;
	cartridgeCoverUri?: string;
}

export const HashupCartridge = ({ cartridge, cartridgeCoverUri = TextureMap.FALLBACK }: IHashupCartridge) => {
	const isLoading = useMemo(() => cartridge === Cartridge._, [cartridge]);
	const sizeScalarDelta = 4.4;

	return (
		<Canvas camera={{ position: [0, 0, sizeScalarDelta], fov: 30 }}>
			<Suspense fallback={null}>
				<HashupCartridgeModel
					cartridge={cartridge}
					coverTextureUri={cartridgeCoverUri}
				/>

				<Environment files={hdrMaps[cartridge]} />
				{isLoading && <Spinner boxSize="20px" />}

				<OrbitControls
					makeDefault
					autoRotate
					autoRotateSpeed={0.75}
					enablePan={false}
					enableZoom={false}
				/>

				<EffectComposer multisampling={8}>
					<SMAA />
					<Bloom
						kernelSize={2}
						luminanceThreshold={0.4}
						luminanceSmoothing={0.4}
						intensity={0.6}
					/>
					<Bloom
						kernelSize={1}
						luminanceThreshold={0.4}
						luminanceSmoothing={0}
						intensity={0.5}
					/>
					{/*<HueSaturation
						blendFunction={14} // blend mode
						hue={0} // hue in radians
						saturation={0.005} // saturation in radians
					/>*/}
				</EffectComposer>
			</Suspense>
		</Canvas>
	);
};
